<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <wml-button-one [params]="params.verifyBtn"></wml-button-one>
  </section>
  <div *ngIf="params.verifyMsgContainer.isPresent" [class]="classPrefix('Pod1')">
    <i [class]="'fa-solid fa-medal '+ classPrefix('Pod1Icon0')"></i>
    <p [class]="classPrefix('Pod1Text0')">{{params.verifyMsg.text | translate}}</p>
  </div>
</div>
